import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import devConfig from './config.dev.js';
import prodConfig from './config.prod.js';

const config = process.env.REACT_APP_ENV === 'prod' ? prodConfig : devConfig;
const database = process.env.REACT_APP_ENV === 'prod' ? 'mogged-mvp-prod' : 'mogged-mvp-dev';
// Initialize Firebase
const app = initializeApp(config);

// App Check — proves callable requests come from the genuine app (reCAPTCHA v3
// attestation), so scripts/curl with a stolen auth token get no App Check token
// and are rejected once the backend enforces (APP_CHECK_ENFORCE on
// runOraclePipeline). No-op until a site key is configured: register the app
// under Firebase console → App Check with a reCAPTCHA v3 provider, then put the
// site key in config.{dev,prod}.js (appCheckSiteKey) or REACT_APP_APPCHECK_SITE_KEY.
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_SITE_KEY || config.appCheckSiteKey;
if (appCheckSiteKey) {
  // Local dev bypasses reCAPTCHA with a debug token (register it in the console
  // under App Check → Apps → Manage debug tokens).
  if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

// Initialize services
const auth = getAuth(app);
const firestore = getFirestore(app, database); // Using Firestore instead of Realtime Database
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');
const analytics = getAnalytics(app);
// Export initialized services
export {
  app,
  auth,
  firestore,
  storage,
  functions,
  analytics
};
